import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "客户状态", -1)
const _hoisted_2 = { style: {"display":"flex","align-items":"center","height":"24px","margin-bottom":"13px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"16px","font-weight":"500"} }, "签到地址", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#999","font-size":"12px"} }, "（添加后才能签到打卡）", -1)
const _hoisted_6 = { style: {"flex":"1 1 0%","text-align":"right"} }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "flex" }

import { computed, nextTick, onMounted, watch, ref, PropType, reactive } from 'vue'
import type { Rule } from 'ant-design-vue/es/form'
import CustomerArea from '@/components/CustomerArea/index'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import SerialSelect from './serialSelect.vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import {
  customerGradeEnum,
  potentialStatusEnum,
  contractStatusEnum,
  clientsStatusEnum,
  customerTypeEnum,
  flagEnum,
  contactTypeEnum,
  linkRoleTypeEnum,
  genderEnum
} from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { potentialAdd, potentialEdit } from '@/api/gucangSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { DcConfirm, message } from '@dc-platform/dc-components'
import { useRoute } from 'vue-router'
import { goBack } from '@/hooks/cosRouter'
import { usePermissionStore } from '@/stores/permission'
import { contactValidate, concatNameValidate, arrayValueValidate, selectForNumberValidate } from '@/utils/validate'
import { cloneDeep } from 'lodash-es'
import calc from '@/utils/calc'
import { initObjectVal, paramCodesDataFilter } from '@/utils/index'
import MapModal from '@/components/MapModal/index.vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'

import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel
} from '@/hooks/addressArrValidate'
import CosInputTianyancha from '@/components/Antd/CosInputTianyancha/index.vue'
import { businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'


const __default__ = { name: 'customerCenterBaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<PotentialItem>,
    default: () => {
      return {
        business: {},
        contact: {}
      }
    }
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  formItemView: {
    type: Boolean
  },
  type: {
    type: String,
    default: 'potential' // 潜在，contract 签约，clients 成交的基本信息
  },
  perfect: {
    type: Boolean,
    default: false
  },
  hideOk: {
    type: Boolean
  }
},
  setup(__props) {

const permissionStore = usePermissionStore()
const permissionBtn = ref<any[]>(permissionStore.permission)
const route = useRoute()
const initForm = reactive<any>({
  business: {
    businessType: [],
    saleInfo: [{}],
    demandInfo: {
      warehouses: [{}]
    },
    erpInfo: [{}],
    replenish: [{}]
  },
  contact: {},
  customerInfo: {},
  visitAddress: [{}]
})
const resetValue = ref(cloneDeep(initForm))
const loading = ref(false)
const form = ref<any>(cloneDeep(initForm))
const props = __props
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      const formVal = v
      initObjectVal(formVal, initForm)
      form.value = cloneDeep(formVal)
      resetValue.value = cloneDeep(formVal)
    }
  },
  { immediate: true }
)
const formRef = ref()
const status = computed(() => {
  // 如果是签约客户编辑，不能选择终止合作
  if (route.path.includes('/fbu/contract/edit')) {
    return cloneDeep(contractStatusEnum).map((item: any) => {
      if (item.value === 22) {
        item.disabled = true
      }
      return item
    })
  }
  if (props.type === 'potential') {
    /// 归档状态不允许选择
    return potentialStatusEnum.map((item) => ({ ...item, disabled: item.value === 14 }))
  } else if (props.type === 'contract') {
    return contractStatusEnum
  } else if (props.type === 'clients') {
    return clientsStatusEnum
  }
  return []
})
/// 文本识别
const clipParseInfo = (parseInfo: any) => {
  if (!parseInfo) {
    return
  }
  let allBlank = false
  if (!form.value.contact.name && !form.value.customerAddress && !form.value.contact.mobile && !form.value.remark) {
    allBlank = true
  }
  if (allBlank) {
    form.value.contact.name = parseInfo.contactName
    form.value.customerAddress = parseInfo.address
    form.value.contact.mobile = parseInfo.phoneNum
    form.value.remark = parseInfo.detail
    return
  }
  DcConfirm.warning({
    title: '操作提示！',
    content: '是否替换原内容',
    cancelText: '取消',
    okText: '继续',
    onOk() {
      form.value.contact.name = parseInfo.contactName
      form.value.customerAddress = parseInfo.address
      form.value.contact.mobile = parseInfo.phoneNum
      form.value.remark = parseInfo.detail
    }
  })
}
const paramCodeData = ref<any>({
  fbu_sales_category: [], // 销售品类
  fbu_product_type: [], // 货物类型
  fbu_warehouse: [], // 合作海外仓
  fbu_sale_platform: [], // 在售电商平台
  fbu_service_demand: [], // 服务需求
  fbu_demand_info: [], // 需求海外仓
  fbu_erp_info: [], // 目前使用ERP
  fbu_replenish_frequency: [], // 头程补货频次
  fbu_business_type: [], // 客户业务类型
  fbu_marketing_activity: [], // 关联市场活动
  fbu_head_replenish_method: [], // 头程补货方式
  fbu_area_code: [], // 电话区号
  fbu_customer_size: [], // 客户规模
  fbu_industrial_belt: [], // 产业带
  fbu_customer_category: []// 客户类别
})
const percentValidate = async (rule: Rule, value: string) => {
  const result = form.value.business.saleInfo.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.percent) || 0),
    0
  )
  if (value && result !== 100) {
    return Promise.reject(new Error('在售平台占比总和等于100%'))
  } else {
    return Promise.resolve()
  }
}
const clearMainAddressFlag = (index: number) => {
  if (form.value.visitAddress) {
    for (const [i, item] of form.value.visitAddress.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_sales_category',
      'fbu_product_type',
      'fbu_warehouse',
      'fbu_sale_platform',
      'fbu_service_demand',
      'fbu_demand_info',
      'fbu_erp_info',
      'fbu_replenish_frequency',
      'fbu_business_type',
      'fbu_marketing_activity',
      'fbu_head_replenish_method',
      'fbu_area_code',
      'fbu_customer_size',
      'fbu_sign_in_address_label',
      'fbu_industrial_belt',
      'fbu_customer_category'
    ]
  }).then((res) => {
    if (res.code === 200) {
      if (!props.disabled) {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
      }
      paramCodeData.value = res.data
    }
  })
}
onMounted(() => {
  getByParamCodes()
})
// 海外仓月销售额
const amount = computed(() => {
  const result = form.value.business.demandInfo.warehouses.reduce(
    (prev: number, curr: any) => calc.Add(prev, Number(curr.amount) || 0),
    0
  )
  return result || 0
})
// 去除数组null ''
const clear = (arr: any[], keys: string[]) => {
  if (!arr) {
    return []
  }
  let result: any = []
  arr.forEach((v: any) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (v[k] != null && v[k] !== '') {
        result.push(v)
        break
      }
    }
  })
  if (!result.length) {
    result = [{}]
  }
  return result
}
const changeIndustrialBeltFlag = () => {
  const { industrialBeltFlag } = form.value.business
  if (industrialBeltFlag === 0) {
    form.value.business.industrialBelt = -9
    form.value.business.industrialBeltLabel = ''
    form.value.business.industrialBeltName = ''
  }
}
const changeIndustrialBeltLabel = () => {
  nextTick(() => {
    const { industrialBeltLabel } = form.value.business
    if (industrialBeltLabel !== '其他') {
      form.value.business.industrialBeltName = ''
    }
  })
}
const handleSubmit = async () => {
  loading.value = true
  const p = cloneDeep(form.value)
  const { replenish, erpInfo, demandInfo, saleInfo } = p.business
  // 地址为空清除、判断地址是否重复
  if (checkAddressData(form.value.visitAddress)) {
    message.error('签到地址不可重复！')
    loading.value = false
    return false
  }
  const { visitAddress } = p
  p.visitAddress = clear(visitAddress, ['addressName'])
  // 新增、编辑的格式和详情不同、多传attrList
  if (JSON.stringify(p.visitAddress) === '[{}]') {
    p.visitAddress = { attrList: [] }
  } else {
    p.visitAddress = { attrList: p.visitAddress }
  }
  if (p.business) {
    p.business.replenish = clear(replenish, ['replenishId', 'frequency', 'replenishment'])
    p.business.erpInfo = clear(erpInfo, ['erpId', 'erpAccount'])
    p.business.saleInfo = clear(saleInfo, ['salePlatformId', 'percent'])
    if (demandInfo && demandInfo.warehouses) {
      p.business.demandInfo.warehouses = clear(demandInfo.warehouses, ['warehouseId', 'amount'])
    }
  }
  try {
    if (route.query.cosId) {
      await potentialEdit(p)
      message.success('编辑成功')
    } else {
      await potentialAdd(p)
      message.success('新增成功')
    }
    goBack()
  } catch (error) {}
  loading.value = false
}

// 新增列
const handleAddCol = (arr: {}[]) => {
  arr.push({})
}
// 删除列
const handleDelCol = (arr: {}[], index: number) => {
  arr.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosRadioGroup = _resolveComponent("CosRadioGroup")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      name: "advanced_search",
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, { title: "基本信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'customerName'],
              label: "客户名称",
              rules: {
          message: '请输入',
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(CosInputTianyancha, {
                  value: form.value.customerInfo.customerName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.customerInfo.customerName) = $event)),
                  maxlength: 50,
                  placeholder: "请输入",
                  appId: "cos_fbu",
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "主客户代码",
              name: ['customerInfo', 'customerNumber'],
              rules: 
          __props.perfect && __props.type !== 'potential'
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(SerialSelect, {
                  value: form.value.customerInfo.customerNumber,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerInfo.customerNumber) = $event)),
                  cosId: _unref(route).query.cosId,
                  view: __props.formItemView,
                  requiredCosId: true,
                  disabled: !__props.formItemView && !permissionBtn.value.includes(__props.permissionPage.editCode) ? true : false
                }, null, 8, ["value", "cosId", "view", "disabled"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "客户状态",
              name: ['customerInfo', 'status'],
              rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
            }, {
              label: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  placement: "topLeft",
                  overlayStyle: { maxWidth: '800px' }
                }, {
                  title: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(status.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.value
                      }, [
                        _createElementVNode("p", null, _toDisplayString(item.label) + _toDisplayString(item.desc ? `：${item.desc}` : ''), 1)
                      ]))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _hoisted_1,
                    _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.customerInfo.status,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.customerInfo.status) = $event)),
                  allowClear: "",
                  placeholder: "请选择",
                  disabled: __props.disabled || __props.type === 'clients',
                  options: status.value,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "客户类型",
              name: ['customerInfo', 'type'],
              rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.customerInfo.type,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.customerInfo.type) = $event)),
                  options: _unref(customerTypeEnum),
                  placeholder: "请选择",
                  "allow-clear": "",
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            (__props.formItemView && __props.type === 'clients')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_dc_form_item, { label: "档次" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.level,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.customerInfo.level) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "成交金额（万）" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.turnoverAmount,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.customerInfo.turnoverAmount) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户评级" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.customerInfo.grade,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.customerInfo.grade) = $event)),
                        options: _unref(customerGradeEnum),
                        view: __props.formItemView,
                        placeholder: "请选择"
                      }, null, 8, ["value", "options", "view"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: "线索来源",
              name: ['customerInfo', 'channel'],
              rules: {
          required: true,
          message: '请选择'
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(ParamCodeCascader, {
                      value: form.value.customerInfo.channel,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.customerInfo.channel) = $event)),
                      appId: "cos_fbu",
                      paramCode: "fbu_source_channel",
                      status: __props.formItemView ? undefined : 0,
                      disabled: __props.disabled,
                      style: {"width":"33%"},
                      view: __props.formItemView,
                      cosDes: form.value.customerInfo.channelExplain
                    }, null, 8, ["value", "status", "disabled", "view", "cosDes"]),
                    _createVNode(_component_CosInput, {
                      value: form.value.customerInfo.channelExplain,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.customerInfo.channelExplain) = $event)),
                      placeholder: "请输入",
                      style: {"width":"67%"},
                      view: __props.formItemView
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户办公地",
              name: ['customerInfo', 'customerOffice'],
              rules: {
          message: '请选择',
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(CustomerArea), {
                  value: form.value.customerInfo.customerOffice,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.customerInfo.customerOffice) = $event)),
                  view: __props.formItemView,
                  "change-on-select": ""
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "客户详细地址",
              name: ['customerInfo', 'customerAddress'],
              rules: {
          message: '请输入',
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerInfo.customerAddress,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.customerInfo.customerAddress) = $event)),
                  maxlength: 200,
                  placeholder: "请输入",
                  disabled: __props.disabled,
                  view: __props.formItemView
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "工厂详细地址" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.customerInfo.factoryAddress,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.customerInfo.factoryAddress) = $event)),
                  maxlength: 200,
                  placeholder: "请输入",
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "客户规模" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.fbu_customer_size,
                  value: form.value.customerInfo.enterpriseScale,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.customerInfo.enterpriseScale) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "关联市场活动" }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.fbu_marketing_activity,
                  value: form.value.customerInfo.activityId,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.customerInfo.activityId) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: ['customerInfo', 'listedFlag'],
              label: "是否上市"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.customerInfo.listedFlag,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.customerInfo.listedFlag) = $event)),
                  options: _unref(flagEnum),
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "是否内部客户",
              name: ['customerInfo', 'internalCustomersFlag'],
              rules: {
          message: '请选择',
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.customerInfo.internalCustomersFlag,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.customerInfo.internalCustomersFlag) = $event)),
                  options: _unref(flagEnum),
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            (__props.formItemView)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_dc_form_item, { label: "剩余跟进天数" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.remanentFollowDays,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((form.value.customerInfo.remanentFollowDays) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "跟进人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.sellerName,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.customerInfo.sellerName) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.createByName,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.customerInfo.createByName) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户ID" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.cosId,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((form.value.customerInfo.cosId) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  (form.value.customerInfo.status > 19)
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 0,
                        label: "转为签约时间"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: form.value.customerInfo.turnedContract,
                            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.customerInfo.turnedContract) = $event)),
                            view: __props.formItemView,
                            placeholder: "请输入"
                          }, null, 8, ["value", "view"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (form.value.customerInfo.status > 29)
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 1,
                        label: "转为成交时间"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: form.value.customerInfo.turnedTransaction,
                            "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((form.value.customerInfo.turnedTransaction) = $event)),
                            view: __props.formItemView,
                            placeholder: "请输入"
                          }, null, 8, ["value", "view"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (__props.formItemView)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.createTime,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.customerInfo.createTime) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "最后领取时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.lastReceiveTime,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((form.value.customerInfo.lastReceiveTime) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "转潜在时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.customerInfo.turnedPotential,
                        "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((form.value.customerInfo.turnedPotential) = $event)),
                        view: __props.formItemView,
                        placeholder: "请输入"
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "备注",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.customerInfo.remark,
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form.value.customerInfo.remark) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "联系人信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'contactType'],
              label: "联系人类型",
              rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.contact.contactType,
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((form.value.contact.contactType) = $event)),
                  options: _unref(contactTypeEnum),
                  placeholder: "请选择",
                  view: __props.formItemView,
                  allowClear: ""
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "联系人姓名",
              name: ['contact', 'name'],
              rules: [
          {
            message: '请输入',
            required: true
          },
          {
            validator: _unref(concatNameValidate)
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.name,
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((form.value.contact.name) = $event)),
                  view: __props.formItemView,
                  placeholder: "请输入",
                  maxlength: 50
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "手机号",
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.fbu_area_code,
                      value: form.value.contact.mobileRegion,
                      "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((form.value.contact.mobileRegion) = $event)),
                      view: __props.formItemView,
                      cosDes: form.value.contact.mobile,
                      style: {"width":"33%"}
                    }, null, 8, ["options", "value", "view", "cosDes"]),
                    _createVNode(_component_dc_form_item, {
                      span: 24,
                      style: {"width":"67%"},
                      class: "last-compact",
                      name: ['contact', 'mobile'],
                      rules: {
              validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: form.value.contact.mobile,
                          "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((form.value.contact.mobile) = $event)),
                          view: __props.formItemView,
                          placeholder: "请输入"
                        }, null, 8, ["value", "view"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'wechat'],
              label: "微信号",
              rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.wechat,
                  "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((form.value.contact.wechat) = $event)),
                  view: __props.formItemView,
                  placeholder: "请输入"
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'qq'],
              label: "QQ号",
              rules: {
          validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.qq,
                  "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((form.value.contact.qq) = $event)),
                  view: __props.formItemView,
                  placeholder: "请输入"
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              name: ['contact', 'email'],
              label: "邮箱",
              rules: [
          {
            validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value)
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.email,
                  "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((form.value.contact.email) = $event)),
                  view: __props.formItemView,
                  placeholder: "请输入"
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "固定电话",
              class: "form-item_compact"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, {
                  compact: "",
                  class: "cos-view-input-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.fbu_area_code,
                      value: form.value.contact.telRegion,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((form.value.contact.telRegion) = $event)),
                      cosDes: form.value.contact.tel,
                      view: __props.formItemView,
                      style: {"width":"33%"}
                    }, null, 8, ["options", "value", "cosDes", "view"]),
                    _createVNode(_component_dc_form_item, {
                      span: 24,
                      style: {"width":"67%"},
                      class: "last-compact",
                      name: ['contact', 'tel'],
                      rules: {
              validator: (rule, value) => _unref(contactValidate)(rule, value, form.value.contact, formRef.value),
              trigger: 'blur'
            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosInput, {
                          value: form.value.contact.tel,
                          "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((form.value.contact.tel) = $event)),
                          view: __props.formItemView,
                          placeholder: "请输入"
                        }, null, 8, ["value", "view"])
                      ]),
                      _: 1
                    }, 8, ["rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "角色" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.contact.jobRole,
                  "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((form.value.contact.jobRole) = $event)),
                  options: _unref(linkRoleTypeEnum),
                  placeholder: "请选择",
                  "allow-clear": "",
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "部门职务" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.jobDuty,
                  "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((form.value.contact.jobDuty) = $event)),
                  view: __props.formItemView,
                  placeholder: "请输入",
                  maxlength: 50
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "传真号" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: form.value.contact.fax,
                  "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((form.value.contact.fax) = $event)),
                  view: __props.formItemView,
                  placeholder: "请输入",
                  maxlength: 50
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, { label: "性别" }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.contact.sex,
                  "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((form.value.contact.sex) = $event)),
                  view: __props.formItemView,
                  options: _unref(genderEnum)
                }, null, 8, ["value", "view", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: "联系人备注",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: form.value.contact.remark,
                  "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((form.value.contact.remark) = $event)),
                  maxlength: 2000,
                  placeholder: "请输入",
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 6 })
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, {
          title: "签到地址（添加后才能签到打卡）",
          span: 6
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (!__props.disabled)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      type: "primary",
                      ghost: "",
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_unref(handleAddressAdd)(form.value.visitAddress)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.formItemView,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.visitAddress, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '签到地址',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressName'],
                      rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, form.value.visitAddress, 'addressTag', '请选择') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(MapModal, {
                          address: item.addressName,
                          "onUpdate:address": ($event: any) => ((item.addressName) = $event),
                          geoPoint: item.geoPoint,
                          "onUpdate:geoPoint": ($event: any) => ((item.geoPoint) = $event),
                          view: __props.formItemView
                        }, null, 8, ["address", "onUpdate:address", "geoPoint", "onUpdate:geoPoint", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '地址类型',
                      class: _normalizeClass(index ? 'no-form-label' : ''),
                      name: ['visitAddress', index, 'addressTag'],
                      rules: [
            { validator: (rule, value) => _unref(checkAddressValidate)(rule, value, form.value.visitAddress, 'addressName', '请输入') }
          ]
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.fbu_sign_in_address_label,
                            value: item.addressTag,
                            "onUpdate:value": ($event: any) => ((item.addressTag) = $event),
                            disabled: __props.disabled,
                            view: __props.formItemView,
                            allowClear: "",
                            style: {"width":"100%"}
                          }, null, 8, ["options", "value", "onUpdate:value", "disabled", "view"]),
                          (!__props.disabled && form.value.visitAddress && form.value.visitAddress.length > 1)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                danger: "",
                                style: {"padding":"0 0 0 12px"},
                                onClick: ($event: any) => (_unref(handleAddressAddDel)(index, form.value.visitAddress))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_checkbox, {
                            style: {"padding":"3px 0 0 12px","width":"150px"},
                            disabled: __props.disabled,
                            checked: item.mainAddressFlag === 1,
                            onChange: ($event: any) => (clearMainAddressFlag(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("主要")
                            ]),
                            _: 2
                          }, 1032, ["disabled", "checked", "onChange"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "客户业务情况" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (handleAddCol(form.value.business.saleInfo)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "客户业务类型",
              name: ['business', 'businessType'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                type: 'array',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.fbu_business_type,
                  value: form.value.business.businessType,
                  "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((form.value.business.businessType) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "年销售GMV(万)",
              name: ['business', 'annualSales'],
              rules: {
          message: '请输入',
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInputNumber, {
                  value: form.value.business.annualSales,
                  "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((form.value.business.annualSales) = $event)),
                  style: {"width":"100%"},
                  maxlength: 15,
                  min: 0,
                  placeholder: "请输入",
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "销售品类",
              name: ['business', 'salesCategory'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.fbu_sales_category,
                  value: form.value.business.salesCategory,
                  "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((form.value.business.salesCategory) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "货物类型",
              name: ['business', 'cargoType'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.fbu_product_type,
                  value: form.value.business.cargoType,
                  "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((form.value.business.cargoType) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "合作海外仓",
              name: ['business', 'warehouse'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.fbu_warehouse,
                  value: form.value.business.warehouse,
                  "onUpdate:value": _cache[46] || (_cache[46] = ($event: any) => ((form.value.business.warehouse) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "客户类别",
              name: ['business', 'customerCategory'],
              rules: 
          {
                message: '请选择',
                required: true
              }
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  mode: "multiple",
                  options: paramCodeData.value.fbu_customer_category,
                  value: form.value.business.customerCategory,
                  "onUpdate:value": _cache[47] || (_cache[47] = ($event: any) => ((form.value.business.customerCategory) = $event)),
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: "是否供货商",
              name: ['business', 'supplierFlag'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.business.supplierFlag,
                  "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((form.value.business.supplierFlag) = $event)),
                  options: _unref(flagEnum),
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "需要金融产品",
              name: ['business', 'financialProductFlag'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.business.financialProductFlag,
                  "onUpdate:value": _cache[49] || (_cache[49] = ($event: any) => ((form.value.business.financialProductFlag) = $event)),
                  options: _unref(flagEnum),
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "是否分销商",
              name: ['business', 'dealerFlag'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.business.dealerFlag,
                  "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((form.value.business.dealerFlag) = $event)),
                  options: _unref(flagEnum),
                  view: __props.formItemView
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "是否产业带",
              name: ['business', 'industrialBeltFlag'],
              rules: {
          message: '请选择',
          required: true
        }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRadioGroup, {
                  value: form.value.business.industrialBeltFlag,
                  "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((form.value.business.industrialBeltFlag) = $event)),
                  options: _unref(flagEnum),
                  view: __props.formItemView,
                  onChange: changeIndustrialBeltFlag
                }, null, 8, ["value", "options", "view"])
              ]),
              _: 1
            }),
            (form.value.business.industrialBeltFlag === 1)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 0,
                  label: "产业带",
                  name: ['business', 'industrialBelt'],
                  rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      options: paramCodeData.value.fbu_industrial_belt,
                      value: form.value.business.industrialBelt,
                      "onUpdate:value": _cache[52] || (_cache[52] = ($event: any) => ((form.value.business.industrialBelt) = $event)),
                      label: form.value.business.industrialBeltLabel,
                      "onUpdate:label": _cache[53] || (_cache[53] = ($event: any) => ((form.value.business.industrialBeltLabel) = $event)),
                      onChange: changeIndustrialBeltLabel,
                      view: __props.formItemView
                    }, null, 8, ["options", "value", "label", "view"])
                  ]),
                  _: 1
                }, 8, ["rules"]))
              : _createCommentVNode("", true),
            (form.value.business.industrialBelt && form.value.business.industrialBeltLabel === '其他')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: "产业带名称",
                  name: ['business', 'industrialBeltName'],
                  rules: {
          message: '请输入',
          required: true
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: form.value.business.industrialBeltName,
                      "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((form.value.business.industrialBeltName) = $event)),
                      maxlength: 100,
                      placeholder: "请输入",
                      view: __props.formItemView
                    }, null, 8, ["value", "view"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(MultipleItem, { view: __props.formItemView }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.saleInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `saleInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '在售电商平台',
                      span: 6,
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'saleInfo', index, 'salePlatformId'],
                      rules: 
              __props.perfect
                ? {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        salePlatformId: item.salePlatformId,
                        percent: item.percent
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.fbu_sale_platform,
                          value: item.salePlatformId,
                          "onUpdate:value": ($event: any) => ((item.salePlatformId) = $event),
                          view: __props.formItemView
                        }, null, 8, ["options", "value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '在售平台占比(%)',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'saleInfo', index, 'percent'],
                      span: 6,
                      rules: 
              __props.perfect
                ? [
                    {
                      message: '请输入',
                      required: true
                    },
                    {
                      validator: percentValidate
                    }
                  ]
                : [
                    {
                      validator: percentValidate
                    },
                    {
                      message: '请输入',
                      validator: (rule, value) =>
                        _unref(arrayValueValidate)(rule, value, {
                          salePlatformId: item.salePlatformId,
                          percent: item.percent
                        })
                    }
                  ]
            
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.percent,
                            "onUpdate:value": ($event: any) => ((item.percent) = $event),
                            style: {"width":"100%"},
                            maxlength: 15,
                            min: 0,
                            placeholder: "请输入",
                            view: __props.formItemView
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.saleInfo && form.value.business.saleInfo.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.saleInfo, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 24 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "需求海外仓" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  onClick: _cache[55] || (_cache[55] = ($event: any) => (handleAddCol(form.value.business.demandInfo.warehouses)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: "服务需求",
              span: 6,
              name: ['business', 'demandInfo', 'demandIds'],
              rules: 
          __props.perfect
            ? {
                message: '请选择',
                required: true
              }
            : []
        
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.fbu_service_demand,
                  value: form.value.business.demandInfo.demandIds,
                  "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((form.value.business.demandInfo.demandIds) = $event)),
                  mode: "multiple",
                  view: __props.formItemView
                }, null, 8, ["options", "value", "view"])
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_dc_form_item, {
              label: "海外仓月消费总额（万元）",
              span: 6
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: amount.value,
                  placeholder: "请输入",
                  disabled: true,
                  view: __props.formItemView
                }, null, 8, ["value", "view"])
              ]),
              _: 1
            }),
            _createVNode(MultipleItem, { view: __props.formItemView }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.demandInfo.warehouses, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `demandInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '需求海外仓',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'demandInfo', 'warehouses', index, 'warehouseId'],
                      rules: 
              __props.perfect
                ? {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        warehouseId: item.warehouseId,
                        amount: item.amount
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.fbu_demand_info,
                          value: item.warehouseId,
                          "onUpdate:value": ($event: any) => ((item.warehouseId) = $event),
                          view: __props.formItemView
                        }, null, 8, ["options", "value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '海外仓月消费额（万元）',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'demandInfo', 'warehouses', index, 'amount'],
                      rules: 
              __props.perfect
                ? {
                    message: '请输入',
                    required: true
                  }
                : {
                    message: '请输入',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        warehouseId: item.warehouseId,
                        amount: item.amount
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_CosInputNumber, {
                            value: item.amount,
                            "onUpdate:value": ($event: any) => ((item.amount) = $event),
                            maxlength: 15,
                            min: 0,
                            placeholder: "请输入",
                            view: __props.formItemView,
                            style: {"width":"100%"}
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (
                  form.value.business.demandInfo.warehouses && form.value.business.demandInfo.warehouses.length > 1 && !__props.disabled
                )
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.demandInfo.warehouses, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "ERP系统" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  ghost: "",
                  onClick: _cache[57] || (_cache[57] = ($event: any) => (handleAddCol(form.value.business.erpInfo)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.formItemView,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.erpInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `erpInfo${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : 'ERP系统',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'erpInfo', index, 'erpId'],
                      rules: 
              __props.perfect
                ? {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                : {
                    message: '请选择',
                    validator: (rule, value) =>
                      _unref(arrayValueValidate)(rule, value, {
                        erpId: item.erpId,
                        erpAccount: item.erpAccount
                      })
                  }
            
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.fbu_erp_info,
                          value: form.value.business.erpInfo[index].erpId,
                          "onUpdate:value": ($event: any) => ((form.value.business.erpInfo[index].erpId) = $event),
                          view: __props.formItemView
                        }, null, 8, ["options", "value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '关联账号',
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'erpInfo', index, 'erpAccount']
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_CosInput, {
                            value: item.erpAccount,
                            "onUpdate:value": ($event: any) => ((item.erpAccount) = $event),
                            view: __props.formItemView,
                            maxlength: 50,
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.erpInfo && form.value.business.erpInfo.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.erpInfo, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name"]),
                    _createVNode(_component_a_col, { span: 12 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        }),
        _createVNode(_component_dc_layout_card, { title: "补货方式" }, {
          subTitle: _withCtx(() => [
            (!__props.disabled)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  onClick: _cache[58] || (_cache[58] = ($event: any) => (handleAddCol(form.value.business.replenish))),
                  ghost: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(MultipleItem, {
              view: __props.formItemView,
              line: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.business.replenish, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `replenish${index}`
                  }, [
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '头程补货方式',
                      span: 6,
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'replenish', index, 'replenishId'],
                      rules: {
              message: '请选择',
              validator: (rule, value) =>
                _unref(arrayValueValidate)(rule, value, {
                  replenishId: item.replenishId,
                  frequency: item.frequency,
                  replenishment: item.replenishment
                })
            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.fbu_head_replenish_method,
                          value: item.replenishId,
                          "onUpdate:value": ($event: any) => ((item.replenishId) = $event),
                          view: __props.formItemView
                        }, null, 8, ["options", "value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '补货频次',
                      span: 6,
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'replenish', index, 'frequency'],
                      rules: {
              message: '请选择',
              validator: (rule, value) =>
                _unref(arrayValueValidate)(rule, value, {
                  replenishId: item.replenishId,
                  frequency: item.frequency,
                  replenishment: item.replenishment
                })
            }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          options: paramCodeData.value.fbu_replenish_frequency,
                          value: item.frequency,
                          "onUpdate:value": ($event: any) => ((item.frequency) = $event),
                          view: __props.formItemView
                        }, null, 8, ["options", "value", "onUpdate:value", "view"])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: index ? '' : '补货量(kg/m³)',
                      span: 6,
                      class: _normalizeClass([index ? 'no-form-label' : '']),
                      name: ['business', 'replenish', index, 'replenishment'],
                      rules: {
              message: '请输入',
              validator: (rule, value) =>
                _unref(arrayValueValidate)(rule, value, {
                  replenishId: item.replenishId,
                  frequency: item.frequency,
                  replenishment: item.replenishment
                })
            }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_CosInput, {
                            value: item.replenishment,
                            "onUpdate:value": ($event: any) => ((item.replenishment) = $event),
                            view: __props.formItemView,
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value", "view"]),
                          (form.value.business.replenish && form.value.business.replenish.length > 1 && !__props.disabled)
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 0,
                                type: "text",
                                onClick: ($event: any) => (handleDelCol(form.value.business.replenish, index)),
                                danger: "",
                                style: {"padding":"0 0 0 12px"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "class", "name", "rules"]),
                    _createVNode(_component_a_col, { span: 6 })
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["view"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: form.value,
          "onUpdate:value": _cache[59] || (_cache[59] = ($event: any) => ((form).value = $event)),
          resetValue: resetValue.value,
          formRef: formRef.value,
          loading: loading.value,
          onSubmit: handleSubmit,
          disabled: __props.disabled,
          permissionPage: __props.permissionPage
        }, null, 8, ["value", "resetValue", "formRef", "loading", "disabled", "permissionPage"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})